import React, { useEffect, useRef, useState,useContext } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate, useSearchParams, useLocation } from "react-router-dom";

import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from 'sweetalert2'
import useCustomerCreate from "\../../../hooks/useRegisterCustomer";

import JWTContext from '../../../context/JWTContext';
import axios from '../../../utils/axios';
import { useGoogleLogin } from '@react-oauth/google';


const schema = yup.object({
    username: yup.string().required(),
    password: yup.string().min(6).required(),
    rememberMe: yup.boolean(),
}).required();

const AdminLogin = () => {
 
const navigate = useNavigate();
    const [isShowPassword, setIsShowPassword] = React.useState(false);
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const redirectPath = params.get('redirect') || '/';

    const { login: loginAccount, loginWithGoogle } = useContext(JWTContext);

    const [showPassword, setShowPassword] = useState(false);
         const inputClass = (field) =>
        `form-control border-0 border-bottom p-10 text-14 ${
            errors[field] ? "is-invalid" : ""
        }`;


    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        try {
            const result = await loginAccount({
                username: data.username,
                password: data.password,
                rememberMe: data.rememberMe
            });

            console.log('Login result:', result);
            // console.log("login submit result : "+result);
            // Swal.fire({
            //     title: "Success",
            //     text: "Login successfully",
            //     icon: "success"
            // });

            // navigate(redirectPath, { replace: true });
            // navigate(``, { replace: true });

            if (!result?.user?.isSeller){
                navigate("/admin/register-seller-type");
            }else{
                // window.open(`https://seller.sg.iwant-asia.com/login?auth=${result.token}`);
                window.open(`https://seller.id.iwant-asia.com/login?auth=${result.token}`);
            }
            
        } catch (err) {
            //console.log(err);
            Swal.fire({
                title: "Error",
                text: err.message,
                icon: "error"
            });
        }
    };

    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                const { code, state } = tokenResponse;
                // Exchange code for access token
                const tokenExchangeResponse = await axios.post('https://oauth2.googleapis.com/token', {
                    code,
                    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID, // Replace with your Client ID
                    client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET, // Replace with your Client Secret
                    redirect_uri: window.location.origin,
                    grant_type: 'authorization_code',
                });
                const { id_token } = tokenExchangeResponse.data;
                await loginWithGoogle(id_token); // Pass to JWTContext
                // navigate(`https://seller.sg.iwant-asia.com/login?auth=${id_token}`, { replace: true });
                navigate(`https://seller.id.iwant-asia.com/login?auth=${id_token}`, { replace: true });
            } catch (err) {
                Swal.fire({
                    title: 'Error',
                    text: 'Google login failed. Please try again later.',
                    icon: 'error',
                });
            }
        },
        onError: () => {
            Swal.fire({
                title: 'Error',
                text: 'Google login failed. Please try again later.',
                icon: 'error',
            });
        },
        flow: 'auth-code', // Use authorization code flow to get access token
        redirect_uri: window.location.origin, // Must match Google Cloud Console
        scope: 'openid profile email', // Adjust scopes as needed
    });



     return (
        <>
            <section className="banner-form text_inter position-relative" style={{backgroundImage:"url('/assets/images/profile_temp/bgheader.jpg')"}}>
                <div className="bgHalf">

                </div>
                <div className="container h-100 z-3 position-relative">
                    <div className="row align-items-center h-100">
                        <div className="col-12 col-md-6">
                            <div className="p-20 ps-0">
                                <div className="">
                                    <span className="text_quicksand text-56 text-white fw-bold lh-40">Start Selling Today!</span>
                                </div>
                                <div className="">
                                    <span className="text-24 text-white fw-medium ">More than 1000 stores from independent sellers.</span>
                                </div>
                                <div className="mt-20">
                                    <span className="text-14 text-white lh_24">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</span>
                                </div>
                            </div>
                            
                        </div>
                        <div className="col-12 col-md-6 formstyle">
                            <span className="fw-bold text-36 text-white text-center d-block mx-auto text_quicksand">iWant Seller Community</span>
                            <div className="p-20 px-0 ps-md-32 pe-md-0">
                                <div className="bg-white p-20 text_quicksand  mx-auto" style={{borderRadius:"6px", maxWidth:"480px"}}>
                                    <h5 className="mb-52 text-center">
                                        Sign In
                                    </h5>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="form-group mb-24 d-none">
                                                <label className="fw-bold fs-14 fw-normal form-label">
                                                    Choose Plan
                                                </label> 
                                                {/* <select className="form-control text-14 p-10">
                                                    <option><span className="text-main-one-600">Business Plan</span> - $ 12.00/month</option>
                                                </select> */}
                                            </div>
                                            <div className="form-group mb-24">
                                                <input type="text" className={inputClass("username")} placeholder="Enter username" {...register("username")}  />
                                                {errors.username && (
                                                    <small className="text-danger">
                                                    {errors.username.message}
                                                    </small>
                                                )}
                                            </div>
                                            <div className="form-group mb-24 password-switchable position-relative">
                                                {/* <input type="password" className="form-control border-0 border-bottom p-10  text-14" placeholder="Enter Password" {...register("password")}  /> */}
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className={inputClass("password")}
                                                    placeholder="Enter Password"
                                                    {...register("password")}
                                                />
                                                <div className="position-absolute top-0 end-0">
                                                    <button
                                                    type="button"
                                                    className="btn"
                                                    onClick={() => setShowPassword(prev => !prev)}
                                                    >
                                                    {showPassword ? (
                                                        <i className="ph-bold ph-eye-closed  text-black"></i>
                                                    ) : (
                                                        <i className="ph-bold ph-eye  text-black"></i>
                                                    )}
                                                    </button>
                                                    {/* <button type="button" className="btn open"><span className="text-black"><i className="ph-bold ph-eye"></i></span></button>
                                                    <button type="button" className="btn close d-none"><span className="text-black"><i className="ph-bold ph-eye-closed"></i></span></button> */}
                                                </div>
                                                 {errors.password && (
                                                    <small className="text-danger">
                                                    {errors.password.message}
                                                    </small>
                                                )}
                                            </div>
                                            {/* <div className="form-group mb-24 composite mb-60">
                                                <div className="border-bottom">
                                                    <div className="d-flex align-items-center">
                                                        <select className="form-control border-0 p-10 shadow-none  text-14" style={{width:"fit-content"}} {...register("phoneCC")} >
                                                            <option defaultValue="+62" value={"+62"}>+62</option>
                                                        </select>
                                                        <input type="text" className={inputClass("phone")} {...register("phone")} placeholder="Enter Phone Number"  />
                                                    </div>
                                                    
                                                </div>
                                                 {errors.phone && (
                                                    <small className="text-danger">
                                                    {errors.phone.message}
                                                    </small>
                                                )} 
                                            </div> */}
                                            
                                            {/* <button className="btn btn_register font-14 fw-bold text_quicksand"  type="submit" onClick={() => navigate("/registration-document-verification")} >NEXT STEP</button> */}
                                            <button className="btn btn_register font-14 fw-bold text_quicksand"  type="submit" >Login</button>
                                            <div className="my-30 text-align mx-auto text-center" >
                                                or continue with
                                            </div>
                                            <button className="btn btn_register_google font-14 fw-bold text_quicksand" type="button" ><img width={"20px"} height={"20px"} src="/assets/images/logo/google_logo.png" /></button>
                                            <div className="my-30 text-align mx-auto text-center" >
                                                Don't have an account? <Link to={`/admin/register`} className='text-main-one-600 fw-bold'>Register</Link>
                                            </div>

                                    </form>
                                    
                                </div>
                            </div>

                        </div>
                    </div> 

                    
                </div>



            </section>
        </>
      );
    };

    export default AdminLogin;